import { render, staticRenderFns } from "./InventarioItemBemConsumoForm.vue?vue&type=template&id=619c5a3d"
import script from "./InventarioItemBemConsumoForm.vue?vue&type=script&lang=js"
export * from "./InventarioItemBemConsumoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports